export default {



    async SET_CUSTOMERS(state, customers) {
      state.customersAll = customers
      state.totalItems = customers.length
    },
  
    async ADD_NEW_CUSTOMER(state, customer) {
      state.customersAll.splice(0, 0, customer);
      state.totalItems += 1
    },
  
    async UPDATE_CUSTOMER(state, customer) {
      const customerIndex = state.customersAll.findIndex((p) => p.idCustomer == customer.idCustomer)
      Object.assign(state.customersAll[customerIndex], customer)
    },
  
    REMOVE_CUSTOMER(state, idCustomer) {
      const customerIndex = state.customersAll.findIndex((c) => c.idCustomer == idCustomer)
      state.customersAll.splice(customerIndex, 1)
      state.totalItems -= 1
    },
  
    async ADD_CUSTOMER_FILTERED(state, customerFiltered) {
      let objCustomer = {
        id: customerFiltered.idCustomer,
        label: `${customerFiltered.idIlux} | ${customerFiltered.corporateName}`,
        corporateName: customerFiltered.corporateName,
        cpf: customerFiltered.cpf,
        cnpj: customerFiltered.cnpj,
        city: customerFiltered.city,
        address: customerFiltered.address,
        district: customerFiltered.district,
        stateRegistration: customerFiltered.stateRegistration,
        phone: customerFiltered.phone,
        mail: customerFiltered.mail,
        mail2: customerFiltered.mail2,
        defaulter: customerFiltered.defaulter,
        cep: customerFiltered.cep,
        idIlux: customerFiltered.idIlux,
      }
      state.customersFiltered.splice(0, 0, objCustomer);
    },
  
    async SET_CUSTOMERS_FILTERED(state, customersFiltered) {
      let customers = []
      for (let customer of customersFiltered) {
        let objCustomer = {
          id: customer.idCustomer,
          label: `${customer.idIlux} | ${customer.corporateName}`,
          corporateName: customer.corporateName,
          cpf: customer.cpf,
          cnpj: customer.cnpj,
          city: customer.city,
          address: customer.address,
          district: customer.district,
          stateRegistration: customer.stateRegistration,
          phone: customer.phone,
          mail: customer.mail,
          mail2: customer.mail2,
          defaulter: customer.defaulter,
          cep: customer.cep,
          idIlux: customer.idIlux,
        }
        customers.push(objCustomer)
      }
      state.customersFiltered = customers
    },
  
    // Novas mutations para otimização
    SET_LOADING(state, loading) {
      state.isLoading = loading
    },
  
    SET_SEARCH_TERM(state, term) {
      state.searchTerm = term
    },
  
    SET_SEARCH_CACHE(state, { key, data }) {
      state.searchCache.set(key, {
        data,
        timestamp: Date.now()
      })
    },
  
    CLEAR_EXPIRED_CACHE(state) {
      const now = Date.now()
      for (let [key, value] of state.searchCache.entries()) {
        if (now - value.timestamp > state.cacheExpiry) {
          state.searchCache.delete(key)
        }
      }
    },
  
    SET_LAST_FETCH(state, timestamp) {
      state.lastFetch = timestamp
    },
  
    SET_CURRENT_PAGE(state, page) {
      state.currentPage = page
    },
  
    // Mutation para filtrar customers localmente
    FILTER_CUSTOMERS_LOCAL(state, { searchTerm, limit = 50 }) {
      if (!searchTerm || searchTerm.length < 2) {
        // Se não há busca, pegar os primeiros itens
        state.customersFiltered = state.customersAll
          .slice(0, limit)
          .map(customer => ({
            id: customer.idCustomer,
            label: `${customer.idIlux} | ${customer.corporateName}`,
            corporateName: customer.corporateName,
            cpf: customer.cpf,
            cnpj: customer.cnpj,
            city: customer.city,
            address: customer.address,
            district: customer.district,
            stateRegistration: customer.stateRegistration,
            phone: customer.phone,
            mail: customer.mail,
            mail2: customer.mail2,
            defaulter: customer.defaulter,
            cep: customer.cep,
            idIlux: customer.idIlux,
          }))
        return
      }
  
      const term = searchTerm.toLowerCase()
      const filtered = state.customersAll
        .filter(customer => 
          (customer.corporateName && customer.corporateName.toLowerCase().includes(term)) ||
          (customer.idIlux && customer.idIlux.toString().includes(term)) ||
          (customer.cnpj && customer.cnpj.includes(term)) ||
          (customer.cpf && customer.cpf.includes(term))
        )
        .slice(0, limit)
        .map(customer => ({
          id: customer.idCustomer,
          label: `${customer.idIlux} | ${customer.corporateName}`,
          corporateName: customer.corporateName,
          cpf: customer.cpf,
          cnpj: customer.cnpj,
          city: customer.city,
          address: customer.address,
          district: customer.district,
          stateRegistration: customer.stateRegistration,
          phone: customer.phone,
          mail: customer.mail,
          mail2: customer.mail2,
          defaulter: customer.defaulter,
          cep: customer.cep,
          idIlux: customer.idIlux,
        }))
  
      state.customersFiltered = filtered
    }
  }